export class OperationsUrlSettingsSearch {
  // GET
  public static readonly URL_GET_CRITERI_UTENTE_RICERCA: string = '/cfgservice/rs/parametri/CRIT.RICERCA';
  public static readonly URL_GET_CRITERI_CAMBIO_PWD: string = '/cfgservice/rs/parametri/SSO_LDAP_CHANGEPWD_ON';
  public static readonly URL_GET_PROFILO_UTENTE: string = '/cfgservice/rs/parametri/USER_SETTINGS_PAGE_ON'; 
  public static readonly URL_GET_MAX_PREVIEW_FILE_SIZE: string = '/cfgservice/rs/parametri/MAX_PREVIEW_FILE_SIZE'; 
  public static readonly URL_GET_CRITERI_UTENTE_ESTRAZIONE_DATI_CD: string = '/cfgservice/rs/parametri/CRIT.REPORT-CD'; 
  public static readonly URL_GET_CRITERI_UTENTE_ESTRAZIONE_DATI: string = '/cfgservice/rs/parametri/CRIT.REPORT-ES'; 
  public static readonly URL_POST_SEARCH_FACCETTE_GLOBALI: string = '/rs/src/gp/facets';
  public static readonly URL_GET_FEATURE_CONSERVAZIONE_BASE_URL: string = '/cfgservice/rs/parametri/FEATURE_CONSERVAZIONE_BASE_URL'; 
  // POST
  public static readonly URL_POST_SEARCH: string = '/rs/src/gp/pratiche';
  public static readonly URL_POST_SEARCH_PRECEDENTI_CORRELATE: string = '/rs/src/gp/pratiche/precedenti';
  public static readonly URL_SEARCH_RIUNITI: string = '/rs/src/gp/riuniti';
  public static readonly URL_SMART_SEARCH: string = '/smartsearch/rs/search';
  
}
